export enum PayStatus {
    "WAITING" = 1,  //支付中
    "CREATE_FAIL" = 2, //创建失败
    "SUCCESS" = 3, //支付成功
    "FAIL" = 4, //支付失败
    "CANCEL" = 5,  //取消支付
    "TIMEOUT" = 6, // 超时待确定
}

export enum PayStatusName {

}
